import { Injectable } from '@angular/core';

import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { forkJoin, Observable, of } from 'rxjs';
import { ApplicationsApiActions, VppApplicationsResolverActions } from './vpp-applications.actions';

import { AppleApplicationsService, AppleVppService, VppAsset } from '@rocksoft/mdm-sdk-v2';
import { safeMap } from '../effects.helpers';
import { VppApplication } from './vpp-applications.state';

@Injectable()
export class VppApplicationsEffects {
  constructor(
    private readonly actions: Actions,
    private readonly applicationService: AppleApplicationsService,
    private readonly vppService: AppleVppService
  ) {}

  /**
   * The (re)load of the vpp applications has been requested.
   * Effect: we load the state from the api.
   */
  vppApplicationsRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(VppApplicationsResolverActions.vppApplicationsRequested),
      switchMap(() =>
        safeMap(
          this.applicationService.getVppAssets('2.0').pipe(
            mergeMap((apiVppAssets) =>
              forkJoin(apiVppAssets.map((apiVppAsset) => this.getVppAssetMetadata(apiVppAsset)))
            ),
            map((assetsWithMetadata) => assetsWithMetadata.filter((assetWithMetadata) => !!assetWithMetadata.bundleId))
          ),
          (vppApplications) =>
            ApplicationsApiActions.vppApplicationsLoaded({
              applications: vppApplications,
            }),
          (error) => ApplicationsApiActions.vppApplicationsLoadedError({ error })
        )
      )
    );
  });

  getVppAssetMetadata = (vppAsset: VppAsset): Observable<VppApplication> => {
    return this.vppService
      .getVppApplicationsMetadata('2.0', parseInt(vppAsset.adamIdStr))
      .pipe(
        map((res) => {
          return {
            bundleId: res.bundleId,
            name: res.name,
            version: res.version,
            iconUrl: res.iconUrl,
            vppAsset: res.vppAsset,
            adamIdStr: res.vppAsset?.adamIdStr ?? undefined,
          };
        })
      )
      .pipe(catchError((error) => of(error)));
  };
}
